const initialState = {
  locationGroupsForm: JSON.parse(localStorage.getItem('locationGroupsForm')) || {},
  allLocationGroups: [],
  loading: false, // General loading state for all actions
  deleteLoading: false, // Loading state specifically for delete action
  error: null,
  all_permission: [],
  get_company_group_list: [],
  get_all_location_group_list: []
};

const locationGroupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ALL_LOCATION_GROUPS':
      return { ...state, allLocationGroups: action.payload, loading: false, error: null };

    case 'GET_ALL_LOCATION_GROUPS_LIST_SUCCESS':
    return { ...state, get_all_location_group_list: action.payload, loading: false, error: null };
    case 'DELETE_GROUP_LOCATIONS':
      return {
        ...state,
        allLocationGroups: state.allLocationGroups.filter(group => group.locationGroupId !== action.payload), // Remove deleted group
        deleteLoading: false, // Stop delete loading after deletion
      };

      case 'GET_GROUP_COMPANY_LIST_SUCCESS':
        return {
          ...state,
          get_company_group_list: action.payload,
          deleteLoading: false,
        };      

      case 'UPDATE_LOCATION_GROUPS':
      return {
        ...state,
        allLocationGroups: state.allLocationGroups.map((group) =>
          group.id === action.payload.id ? action.payload : group
        ),
      };
     
      
    case 'START_DELETE_LOADING':
      return { ...state, deleteLoading: true }; // Start delete loading

    case 'STOP_DELETE_LOADING':
      return { ...state, deleteLoading: false }; // Stop delete loading

    case 'GET_LOCATION_GROUPS_FAILURE':
      return { ...state, error: action.payload, loading: false, deleteLoading: false };

    case 'GET_ALL_USER_PERMISSION':
    return { ...state, all_permission: action.payload, loading: false, };
      
    default:
      return state;
  }
};

export default locationGroupsReducer;
